import { render, staticRenderFns } from "./SepehrMemberCallback.vue?vue&type=template&id=210f1bc0&scoped=true"
import script from "./SepehrMemberCallback.vue?vue&type=script&lang=js"
export * from "./SepehrMemberCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f1bc0",
  null
  
)

export default component.exports